import React, { useEffect, useState } from 'react';
import { Flex } from 'antd';
import g from '@/general.module.scss';
import WithMainContainer from '@/components/layout';
import { Button, Carousel, Layout, Typography } from 'antd';
import Link from 'next/link';
import mp from './MainPage.module.scss';
import OurPartners from '@/components/OurPartners/OurPartners';
import PopularCategories from '@/components/MainPage/PopularCategories/PopularCategories';
import Head from 'next/head';
import logo from '/public/static/images/image_logo_full.svg';
import { useStores } from '@/utils/hooks/useStores';
import Image from 'next/image';
import icon_markdown from '/public/static/images/icon_markdown.svg';
import { observer } from 'mobx-react-lite';
import useLocalization from 'tkmp-lib/src/hooks/useLocalization';
import { ArrowRightOutlined, CheckOutlined } from 'tkmp-lib/src/icons/icons';
import HeadService from '@/utils/services/HeadService';
import { useRouter } from 'next/router';

type TInfoBlock = {
    key: number;
    title: string | React.JSX.Element;
};

export async function getServerSideProps(context: any) {
    const cookies = context?.req?.cookies;
    return {
        props: {},
    };
}

function MainPage() {
    const LOCALIZATION = useLocalization();
    const router = useRouter();
    const [isAuthorized, setIsAuthorized] = useState<boolean>(false);
    const {
        userStore: { USERNAME },
        modalsStore: { openRegisterForm },
        systemStore: { setBreadcrumbs },
    } = useStores();

    useEffect(() => {
        setBreadcrumbs([]);
    }, []);

    useEffect(() => {
        setIsAuthorized(USERNAME !== '');
    }, [USERNAME]);

    const platformAbilities: TInfoBlock[] = [
        {
            key: 0,
            title: LOCALIZATION.pages.index.secondCard.first,
        },
        {
            key: 1,
            title: LOCALIZATION.pages.index.secondCard.second,
        },
        {
            key: 2,
            title: LOCALIZATION.pages.index.secondCard.third,
        },
    ];

    const platformAdvantages: TInfoBlock[] = [
        {
            key: 0,
            title: LOCALIZATION.pages.index.fourthCard.first,
        },
        {
            key: 1,
            title: LOCALIZATION.pages.index.fourthCard.second,
        },
        {
            key: 2,
            title: LOCALIZATION.pages.index.fourthCard.third,
        },
        {
            key: 3,
            title: LOCALIZATION.pages.index.fourthCard.fourth,
        },
    ];

    const platformGuide: TInfoBlock[] = [
        {
            key: 1,
            title: (
                <>
                    <span
                        onClick={() => {
                            if (!isAuthorized) openRegisterForm();
                        }}
                        style={{ color: isAuthorized ? '#0B0B0C' : '#8A24F8' }}
                        className={`text-16-400 ${!isAuthorized ? g.button_link : ''}`}
                    >
                        {LOCALIZATION.pages.index.thirdCard.firstButton}
                    </span>
                    <span
                        className="text-16-400"
                        style={{ color: '#0B0B0C' }}
                    >
                        {' '}
                        {LOCALIZATION.pages.index.thirdCard.first}
                    </span>
                </>
            ),
        },
        {
            key: 2,
            title: LOCALIZATION.pages.index.thirdCard.second,
        },
        {
            key: 3,
            title: LOCALIZATION.pages.index.thirdCard.third,
        },
    ];

    return (
        <>
            {process.env.NEXT_PUBLIC_INCLUDE_SEO_TAGS === 'true' &&
                HeadService.simpleBuild('TKMP.Istok - B2B Маркетплейс для Бизнеса', '')}
            <Layout className={mp.container}>
                <Carousel className={mp.carousel}>
                    <div className={`${mp.carouselCard}`}>
                        <span className={router.locale === 'ru' ? `${mp.spanBlock} ${mp.spanBlockRu}` : mp.spanBlock}>
                            {LOCALIZATION.pages.index.firstCard.title}
                        </span>
                        {!isAuthorized && (
                            <Button
                                onClick={() => {
                                    openRegisterForm();
                                }}
                                type="primary"
                                className={mp.carouselButton}
                            >
                                {LOCALIZATION.pages.index.firstCard.registerButton}
                            </Button>
                        )}
                    </div>
                </Carousel>
                <Layout className={`${mp.moduleBlock} ${mp.layout1}`}>
                    {platformAbilities.map((ability) => (
                        <div
                            key={ability.key}
                            className={mp.moduleBlock_header}
                        >
                            <Image
                                src={icon_markdown}
                                width={0}
                                height={0}
                                sizes={'100%'}
                                alt={''}
                            />
                            <span className={`${mp.title}`}>{ability.title}</span>
                        </div>
                    ))}
                </Layout>
                <Layout className={`${mp.moduleBlock} ${mp.layout2}`}>
                    <Flex
                        justify={'space-between'}
                        align={'flex-start'}
                        style={{ width: '100%' }}
                    >
                        <Typography.Text className="text-32-500">
                            {LOCALIZATION.pages.index.thirdCard.title}
                        </Typography.Text>
                        <Link
                            href={'/help?category=suppliers&page=instructionsForManufacturers'}
                            passHref
                        >
                            <Button
                                type="text"
                                className="text-14-400"
                            >
                                {LOCALIZATION.pages.index.thirdCard.buttonExtend}
                                <ArrowRightOutlined />
                            </Button>
                        </Link>
                    </Flex>
                    <Layout className={mp.guideContainer}>
                        {platformGuide.map((guide) => (
                            <Flex
                                key={guide.key}
                                className={mp.guideBlock}
                                align={'flex-start'}
                                style={{ gap: '24px', width: '100%' }}
                            >
                                <span className={mp.circle}>{guide.key}</span>
                                <div>
                                    {typeof guide.title === 'string' ? (
                                        <span className={`text-16-400 text-[#0B0B0C]`}>
                                            {guide.title}
                                        </span>
                                    ) : (
                                        guide.title
                                    )}
                                </div>
                            </Flex>
                        ))}
                    </Layout>
                </Layout>
                <Layout className={`${mp.moduleBlock} ${mp.layout3}`}>
                    <Layout className={mp.layout3_topBlock}>
                        <Typography.Text className="text-32-500">
                            {LOCALIZATION.pages.index.fourthCard.title}
                        </Typography.Text>
                        <Link
                            href={'/help?category=aboutProject'}
                            passHref
                        >
                            <Button
                                type="text"
                                className={`text-14-400 ${mp.topButton}`}
                            >
                                {LOCALIZATION.pages.index.fourthCard.buttonExtend}{' '}
                                <ArrowRightOutlined />
                            </Button>
                        </Link>
                    </Layout>
                    <Layout className={mp.layout3_bodyBlock}>
                        {platformAdvantages.map((advantage) => (
                            <div
                                key={advantage.key}
                                className={mp.layout3_bodyBlock__block}
                            >
                                <CheckOutlined />
                                <Typography.Text className="text-16-400 text-[#0B0B0C]">
                                    {advantage.title}
                                </Typography.Text>
                            </div>
                        ))}
                    </Layout>
                </Layout>
                <PopularCategories />
                <OurPartners />
            </Layout>
        </>
    );
}

export default WithMainContainer(observer(MainPage));
